import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ButtonIconStatus } from '../../../enums/button-icon-status.enum';
import { ButtonTypes } from '../../../enums/button-type.enum';
import { Button } from '../../../models/button.model';

@Component({
  selector: 'lns-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss']
})
export class ButtonComponent implements OnInit {
  @Input() buttonContent: Button = {};
  @Input() disabled = false;
  @Output() clickEvent = new EventEmitter();

  private defaultButton: Button = {
    type: ButtonTypes.Primary,
    height: '60',
    width: '142',
    iml: '10',
    imr: '10',
    iconHeight: '12'
  };

  buttonIconStatus = ButtonIconStatus;
  buttonTypes = ButtonTypes;

  ngOnInit(): void {
    this.buttonContent = { ...this.defaultButton, ...this.buttonContent };
  }

  buttonClicked(): void {
    this.clickEvent.emit();
  }
}
